export const ASSIGNMENT_MODEL_TYPES = {
    POOL: 'Pool',
    PLACEMENT: 'Placement'
  };

  export const getAssignmentModelDescription = (assignmentModelType) => {
    switch (assignmentModelType) {
      case ASSIGNMENT_MODEL_TYPES.POOL:
        return 'Pool = soft bench. Bench is discoverability only. MoR = org-unit representative unless true FT.';
      case ASSIGNMENT_MODEL_TYPES.PLACEMENT:
        return 'Placement = hard bench. Bench is part of lifecycle. MoR = project representative when FT, else bench-based inheritance.';
      default:
        return assignmentModelType;
    }
  };
  
  export const getAssignmentModelTypeName = (assignmentModelType) => {
    switch (assignmentModelType) {
      case ASSIGNMENT_MODEL_TYPES.POOL:
        return 'Pool';
      case ASSIGNMENT_MODEL_TYPES.PLACEMENT:
        return 'Placement';
      default:
        return assignmentModelType;
    }
  };
  
  export const getAssignmentModelTypeBackgroundColor = (assignmentModelType) => {
    switch (assignmentModelType) {
      case ASSIGNMENT_MODEL_TYPES.POOL:
        return '#E0F2FE';
      case ASSIGNMENT_MODEL_TYPES.PLACEMENT:
        return '#FFE8CC';
      default:
        return '#F3F4F6';
    }
  };
  
  export const getAssignmentModelTypeTextColor = (assignmentModelType) => {
    switch (assignmentModelType) {
      case ASSIGNMENT_MODEL_TYPES.POOL:
        return '#0369A1';
      case ASSIGNMENT_MODEL_TYPES.PLACEMENT:
        return '#CC5500';
      default:
        return '#6B7280';
    }
  };